
const searchBoxStyle = theme => ({
	searchContainer: {
		float: "right"
	},
	search: {
		margin: "0",
		paddingTop: "7px",
		paddingBottom: "7px",
		[theme.breakpoints.down("sm")]: {
			margin: "10px 15px",
			float: "none !important",
			paddingTop: "1px",
			paddingBottom: "1px",
			padding: "10px 15px",
			width: "auto"
		}
	},
	searchInput: {
		paddingTop: "2px"
	},
	searchButton: {
		[theme.breakpoints.down("sm")]: {
			top: "-50px !important",
			marginRight: "38px",
			float: "right"
		}
	},
	top: {
		zIndex: "4"
	},
	searchIcon: {
		width: "17px",
		zIndex: "4"
	},
	headerLinksSvg: {
		width: "20px !important",
		height: "20px !important"
	},
});

export default searchBoxStyle;
